import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const KnowledgeListContainer = React.lazy(
  () => import('../../containers/knowledge-list/knowledge-list.container')
);

const { KNOWLEDGE_BASE_LIST } = APP_ROUTES.KNOWLEDGE_BASE_MODULE.CHILDREN as RouteConfig;

export const KnowledgeRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={KNOWLEDGE_BASE_LIST.FULL_PATH} />
  },
  {
    path: KNOWLEDGE_BASE_LIST.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN, UserRole.E_COMMERCE_MANAGER]}
          component={KnowledgeListContainer}
        />
      </React.Suspense>
    )
  }
];
